import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
// import { ContextMenuService } from 'ngx-contextmenu'; // TODO: Replace with Angular 18 compatible context menu
import { PannellumStadiumCamera } from 'app/models/pannellum-stadium-camera';
import { DomElementService } from 'app/services/dom-element.service';
import { StadiumCameraComponent } from 'app/shared/components/stadium-camera/stadium-camera.component';
import { CompetitionService } from 'app/services/competition.service';
import { FileStatus } from 'app/models/file-status.enum';
import { SharepointService } from 'app/services/sharepoint.service';
import { SharepointData } from 'app/models/sharepoint-data';
import { Stadium } from 'app/models/stadium';
import { StadiumCamera } from 'app/models/stadium-camera';
import {GoogleTagManagerService} from 'app/services/google-tag-manager.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-stadium-camera-360',
  templateUrl: './stadium-camera-360.component.html',
  styleUrls: ['./stadium-camera-360.component.scss'],
})
export class StadiumCamera360Component implements AfterViewInit, OnChanges {
    public containerId: string;
    private viewer: any;
    @Input() lookingAtCamera: PannellumStadiumCamera;
    @Input() stadium: Stadium;
    @Input() isAdmin: boolean;
    @Output() onDeleteCamera = new EventEmitter<string>()
    @Output() onSelectCamera = new EventEmitter<PannellumStadiumCamera>()
    @Output() onUpdateCamera = new EventEmitter<void>()

    constructor(
        private competitionService: CompetitionService,
        // private contextMenuService: ContextMenuService, // TODO: Replace with Angular 18 compatible context menu
        private sharepointService: SharepointService,
        private domElementService: DomElementService,
        private gtmService: GoogleTagManagerService,
        private router: Router,
    ) {
        this.containerId = `stadium-camera-360-${Math.random().toString(36).substring(2)}`
    }

    getCameraData(): PannellumStadiumCamera[] {
        return this.stadium.pannellumStadiumCamera.map(item =>
            // Make a copy of the object, so that it doesn't change inside the Pannellum config (it's not possible to refresh it anyway)
            Object.assign({...item}, {
                type: 'info',
                cssClass: ((isNaN(item.posName as any)) ? 'camera-letter' : 'camera-number') + ' camera-detail',
                // StadiumCamera view is inserted into the DOM and changed by angular so we want to keep the original here
                createTooltipArgs: item.createTooltipArgs,
                createTooltipFunc: (hotSpotDiv: HTMLDivElement, stadiumCamera: StadiumCamera) => {
                    this.setCameraPos(hotSpotDiv, stadiumCamera);
                    hotSpotDiv.setAttribute('data-number', item.posName)
                    if (this.isAdmin) {
                        hotSpotDiv.setAttribute('draggable', 'true')
                        hotSpotDiv.addEventListener('contextmenu', this.handleRightClickOnCamera.bind(this, item))
                        hotSpotDiv.addEventListener('dragstart', (event) => {
                            // @ts-ignore
                            event.target.classList.remove('clicked')
                            event.dataTransfer.effectAllowed = 'move'
                            event.dataTransfer.setData('pannellum/hot-spot', item.id)
                        })
                    }
                },
                clickHandlerFunc: (event) => {
                    const siblings = this.domElementService.getSiblings(event.target);
                    if (event.target.classList.contains('camera-detail') && !event.target.classList.contains('clicked')) {
                        const urlParts = this.router.url.split('/').filter(s => s);
                        const gtmData = {
                            parentParams: { id: urlParts[0] || null },
                        };
                        this.gtmService.pushVirtualPageView('stadium', null, gtmData);
                    }
                    siblings.forEach(element => element && element.classList && element.classList.remove('clicked'));
                    event.target.classList.toggle('clicked');
                },
            })
        );
    }

    @HostListener('dblclick', ['$event'])
    private handleDoubleClick = (event: MouseEvent): void => {
        if (this.isAdmin) {
            const target: HTMLElement = event.target as HTMLElement
            // ignore clicking on other elements
            if (target.classList.contains('pnlm-dragfix')) {
                const coords: number[] = this.viewer.mouseEventToCoords(event)
                this.createNewHotSpot(coords[0], coords[1])
            }
        }
    }

    @HostListener('dragover', ['$event'])
    private handleHotSpotDragOver(event) {
        if (this.isAdmin) {
            event.dataTransfer.dropEffect = 'move'
            if (event.dataTransfer.types.includes('pannellum/hot-spot')) {
                event.preventDefault()
            }
        }
    }

    @HostListener('drop', ['$event'])
    private handleHotSpotDrop(event) {
        if (this.isAdmin) {
            const id = event.dataTransfer.getData('pannellum/hot-spot')
            for (const k in this.stadium.pannellumStadiumCamera) {
                const camera = this.stadium.pannellumStadiumCamera[k]
                if (camera.id === id) {
                    const coords = this.viewer.mouseEventToCoords(event)
                    camera.pitch = Number(coords[0].toFixed(1))
                    camera.yaw = Number(coords[1].toFixed(1))
                    this.refreshPannellumHotSpots()
                    this.onUpdateCamera.emit()
                    break
                }
            }
        }
    }

    private handleRightClickOnCamera = (camera: PannellumStadiumCamera, $event: MouseEvent): void => {
        // TODO: Replace with Angular 18 compatible context menu
        // this.contextMenuService.show.next({
        //     event: $event,
        //     item: camera,
        // });
        $event.preventDefault();
        $event.stopPropagation();
    }

    setCameraPos(hotSpotDiv: HTMLDivElement, stadiumCamera: StadiumCamera) {
        this.domElementService.appendComponent(
            hotSpotDiv,
            StadiumCameraComponent, {
                stadiumCamera,
                isAdmin: this.isAdmin,
                hotSpotDiv,
            }
        );

        hotSpotDiv.addEventListener('mouseover', () => {
            stadiumCamera.status = FileStatus.Active;
        });
    }

    initPannellumView(stadiumCameraHotSpots: Array<PannellumStadiumCamera>) {
        const stadium = {
            type: 'equirectangular',
            // panorama: '/assets/img/uefa-nationals-league-stadium-360.jpg',
            // 'panorama': 'https://uefaqa-view.thron.com/api/xcontents/resources/delivery/getThumbnail/uefaqa/800x428/94099ff6-2469-45ef-913a-f0269f0c4328.jpg?v=13&dpr=1200',
            // panorama: 'https://uefaqa-view.thron.com/api/xcontents/resources/delivery/getThumbnail/uefaqa/800x428/94099ff6-2469-45ef-913a-f0269f0c4328.jpg?v=13&dpr=600',
            // 'panorama': 'https://uefaqa-view.thron.com/api/xadmin/resources/content/downloadSource?clientId=uefaqa&xcontentId=94099ff6-2469-45ef-913a-f0269f0c4328',
            panorama: '',
            autoLoad: true,
            mouseZoom: false,
            hotSpots: stadiumCameraHotSpots,
            showFullscreenCtrl: false,
        }

        const competition = this.competitionService.getCompetitionSelected();
        console.debug('stadium bg', competition?.assetStadium)

        if (competition && competition.assetStadium) {
            // Fix: Backend constructs URL as "${fileId}_${fileName}", but DB has fileName=fileId causing duplication
            // So we pass only fileId in the fileUrl by modifying the URL directly
            const asset = this.competitionService.getCompetitionSelected().assetStadium;
            const sharePointFile: SharepointData = {
                ...asset,
                mimeType: 'image/*',
                // Replace the duplicated filename in fileUrl with just fileId
                fileUrl: asset.fileUrl.replace(`${asset.fileId}_${asset.fileName}`, asset.fileId)
            };
            this.sharepointService.downSharepointFile(sharePointFile)
                .subscribe({
                    next: (file) => {
                        console.debug('file stadium', file);
                        stadium.panorama = (file &&
                         file.content &&
                         file.content.size > 0 )
                         ? URL.createObjectURL(file.content)
                         : '../../../../assets/img/stadium_old.jpg';
                        this.viewer = pannellum.viewer(this.containerId, stadium);
                        console.debug('file content', file.content);
                    },
                    error: (err) => {
                        console.error('Failed to load stadium background, using default', err);
                        stadium.panorama = '../../../../assets/img/stadium_old.jpg';
                        this.viewer = pannellum.viewer(this.containerId, stadium);
                    }
                });
        } else {
            stadium.panorama ='../../../../assets/img/stadium_old.jpg';
            this.viewer = pannellum.viewer(this.containerId, stadium);
        }
    }

    private contextMenuCanEdit = (camera: PannellumStadiumCamera): boolean => {
        return !this.lookingAtCamera || camera.id !== this.lookingAtCamera.id
    }

    private contextMenuDelete = (camera: PannellumStadiumCamera): void => {
        if (confirm(`Are you sure you want to delete "${camera.posName}"?`)) {
            this.onDeleteCamera.emit(camera.id)
        }
    }

    private createNewHotSpot = (pitch: number, yaw: number): PannellumStadiumCamera => {
        const camera = <PannellumStadiumCamera> {
            id: Math.random().toString(36).substring(2),
            posName: '?',
            pitch: Number(pitch.toFixed(1)),
            yaw: Number(yaw.toFixed(1)),
            createTooltipArgs: {
                files: [],
            },
        }

        this.stadium.pannellumStadiumCamera.push(camera)
        this.onSelectCamera.emit(camera)
        this.lookAtCamera(camera)
        this.refreshPannellumHotSpots()

        return camera
    }

    public refreshPannellumHotSpots() {
        const stadiumCameraHotSpots = this.getCameraData()
        const currentHotSpots: Map<string, PannellumStadiumCamera> =
            this.viewer.getConfig().hotSpots.reduce((map, v) => map.set(v.id, v), new Map)

        const newHotSpots: Map<string, PannellumStadiumCamera> =
            stadiumCameraHotSpots.reduce((map, v) => map.set(v.id, v), new Map)

        for (const hotSpot of currentHotSpots.values()) {
            const id = hotSpot.id
            if (newHotSpots.has(id)) {
                if (!this.compareHotSpots(hotSpot, newHotSpots.get(id))) {
                    this.viewer.removeHotSpot(id)
                    this.viewer.addHotSpot(newHotSpots.get(id))
                }
            } else {
                this.viewer.removeHotSpot(id)
            }
        }

        for (const hotSpot of newHotSpots.values()) {
            if (!currentHotSpots.has(hotSpot.id)) {
                this.viewer.addHotSpot(hotSpot)
            }
        }
    }

    private compareHotSpots(a: PannellumStadiumCamera, b: PannellumStadiumCamera): boolean {
        return a.pitch === b.pitch && a.yaw === b.yaw && a.posName === b.posName
    }

    lookAtCamera(camera: PannellumStadiumCamera) {
        this.viewer.lookAt(camera.pitch, camera.yaw, 90, 600);
    }

    ngAfterViewInit() {
        const competition = this.competitionService.getCompetitionSelected();
        if (competition) {
            const stadiumCameraHotSpots = this.getCameraData();
            this.initPannellumView(stadiumCameraHotSpots);
        } else {
            // Wait for competition to load before initializing
            const subscription = this.competitionService.getCompetitionSelectedSubscriber()
                .subscribe((asset) => {
                    if (asset) {
                        const stadiumCameraHotSpots = this.getCameraData();
                        this.initPannellumView(stadiumCameraHotSpots);
                        subscription.unsubscribe();
                    }
                });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.lookingAtCamera && !changes.lookingAtCamera.firstChange) {
            this.lookAtCamera(changes.lookingAtCamera.currentValue);
        }
        if (changes.stadium && this.viewer && this.isAdmin) {
            this.refreshPannellumHotSpots()
        }
    }

}
